export default [
	{
		path: 'copyright',
		name: 'copyright',
		component: () => import('pages/copyright/index'),
	},
];
